<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Création de commande</h2>
                <form @submit.prevent="onUpdateForm">
                    <fieldset class="uk-fieldset">
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.client_name" placeholder="Nom du client" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.depart_address" placeholder="Adresse de depart" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="number" v-model="commande.client_phone" placeholder="Numéro du client" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.dest_address" placeholder="Adresse de destination" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="number" v-model="commande.dest_contact" placeholder="Numéro du destinataire" required>
                    </div>
                    <div class="uk-margin">
                        <input class="uk-input" type="text" v-model="commande.nature" placeholder="Nature du coli (express ou classic)" required> 
                    </div>
                    <div class="uk-margin">
                    <label>Tarifs de la livraison (en FCFA)</label>
                        <input class="uk-input" type="number" v-model="commande.montant" placeholder="Exemple: 1 500 F" required>
                    </div>
                    <div class="uk-margin">
                    <label>Valeur de colis (en FCFA)</label>
                        <input class="uk-input" type="number" v-model="commande.valeur" placeholder="Exemple: 18 000 F" required>
                    </div>

                    </fieldset>
                    <div class="d-flex justify-content-center">
                            <button class="btn btn-round my-3 border-0 px-5" style="background-color:#FFAB0E; color:#fff;  font-size:1em !important; " >Enregistrer</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
  import { db, dbstore, auth } from '../../main';
  import Swal from "sweetalert2";
export default {
    data(){
        return{
            commande: {},
        }
        
    },
    created() {
        let dbRef = db.ref('Colis Futur').child(this.$route.params.id);
        dbRef.get().then((snapshot) => {
            this.commande = snapshot.val();
        }).catch((error) => {
            console.log(error)
        })
    },
    methods: {
        onUpdateForm(event) {
        let go = this
        event.preventDefault();
        db.ref("Colis Requetes").child(this.$route.params.id)
            .set(this.commande)
            .then(() => {
            console.log("Mise à jour effectuée");
            go.$router.push({path:'/admin/livraison/encours'});
                Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Mise à jour éffectuée',
                showConfirmButton: true,
                timer: 4000,
                allowOutsideClick: false,
                })
            })
            .catch((error) => {
            console.log(error);
            });
        },
    }
}
</script>